<template>
  <RModal
    ref="modal"
    :persistent="false"
    :title="`Create new ${departmentLabel.singular.toLowerCase()}`"
    @ok="onSave"
    @cancel="resetFields"
  >
    <Grid gap="var(--r-space-md)" class="q-pt-lg">
      <RInput v-model="name" autofocus :label="`${departmentLabel.singular} name`" no-hint no-feedback-icon />
    </Grid>
  </RModal>
</template>

<script>
import * as apiTo from '@/modular-api'
// Libraries
import { mapGetters } from 'vuex'
// Components
import RModal from '@/ui/RModal'

export default {
  components: {
    RModal
  },

  data: () => ({
    name: ''
  }),

  computed: {
    ...mapGetters('entity-labels', ['departmentLabel'])
  },

  methods: {
    show() {
      this.$refs.modal.show()
    },

    onSave(hideModal, setModalLoading) {
      setModalLoading()

      apiTo
        .CREATE_DEPARTMENT({ name: this.name })
        .then(({ data }) => {
          this.resetFields(hideModal)
          this.$emit('created', data.result)
        })
        .finally(() => setModalLoading(false))
    },

    resetFields(hideModal) {
      this.name = ''
      hideModal()
    }
  }
}
</script>
